import { IAppState } from '../../types';
import { TBanners } from '../../types/newbuildingBanners/banners';

export const selectNewbuildingBanners = (state: IAppState): TBanners[] => {
  return state.newbuildingBanners.data;
};
